export default __webpack_public_path__ + "static/media/arrEq.5ffe4985.png";